/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FeatureLike } from "ol/Feature";
import { Fill, Icon, Stroke } from "ol/style";
import CircleStyle from "ol/style/Circle";
import Style from "ol/style/Style";
import leadingLineIcon from "~/assets/img/seahow-leading-line.png";
import lightHouseIcon from "~/assets/img/seahow-light-house.png";
import minorLightIcon from "~/assets/img/seahow-minor-light.png";
import radarMarkIcon from "~/assets/img/seahow-radar-mark.png";
import sectorLightIcon from "~/assets/img/seahow-sector-line.png";
import { AtoNMapItem } from "../types/mapItems";
import { getAtonIcon } from "./getAtonIcon";

const knownNavigationTypes = [
  "Vasen",
  "Oikea",
  "Pohjois",
  "Itä",
  "Länsi",
  "Etelä",
  "Erikoismerkki",
] as const;
export type KnownNavigationTypes = typeof knownNavigationTypes[number];

export const generateAtoNStyle = (feature: FeatureLike): Style[] => {
  // Use an icon if the type/class/subclass matches a known icon
  // Otherwise use a default style
  const props = feature.getProperties() as AtoNMapItem;
  const finalStyle: Style[] = [];

  const { atonType, navigationType, hasLighting, activeFaultCount } = props;

  const defaultStyle = new Style({
    image: new CircleStyle({
      radius: 10,
      fill: new Fill({
        color: activeFaultCount > 0 ? "#C0392B" : "#E07C24",
      }),
      stroke: new Stroke({
        color: "#000",
        width: 1,
      }),
    }),
  });

  if (knownNavigationTypes.includes(navigationType as KnownNavigationTypes)) {
    finalStyle.push(
      new Style({
        image: new Icon({
          src: getAtonIcon(
            navigationType as KnownNavigationTypes,
            !!hasLighting,
            activeFaultCount > 0,
          ),
          scale: 0.3,
          anchor: [0.13, 0.7],
        }),
      }),
    );
  } else {
    switch (atonType) {
      case "Linjamerkki":
        finalStyle.push(
          new Style({
            image: new Icon({
              src: leadingLineIcon,
              scale: 0.3,
              anchor: [0.14, 0.8],
            }),
          }),
        );
        break;
      case "Sektoriloisto":
        finalStyle.push(
          new Style({
            image: new Icon({
              src: sectorLightIcon,
              scale: 0.3,
              anchor: [0.5, 0.1],
            }),
          }),
        );
        break;
      case "Merimajakka":
        finalStyle.push(
          new Style({
            image: new Icon({
              src: lightHouseIcon,
              scale: 0.3,
              anchor: [0.5, 0.5],
            }),
          }),
        );
        break;
      case "Apuloisto":
        finalStyle.push(
          new Style({
            image: new Icon({
              src: minorLightIcon,
              scale: 0.3,
              anchor: [0.5, 0.5],
            }),
          }),
        );
        break;
      case "Tutkamerkki":
        finalStyle.push(
          new Style({
            image: new Icon({
              src: radarMarkIcon,
              scale: 0.3,
              anchor: [0.5, 0.5],
            }),
          }),
        );
        break;

      default:
        finalStyle.push(defaultStyle);
        break;
    }
  }

  return finalStyle;
};
